module.exports = __webpack_public_path__ + "static/Safari.58b112b3.png";